import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import PortalPage from "../pages/portal/page";
import PortalDashboard from "../pages/portal/dashboard";
import AboutPage from "../pages/about/page";
import PhilosophyPage from "../pages/philosophy/page";
import PropertiesPage from "../pages/properties/page";
import ServicesPage from "../pages/services/page";
import TeamPage from "../pages/team/page";
import ContactPage from "../pages/contact/page";
import LogoExportPage from "../pages/logo-export/page";
import BrandPage from "../pages/brand/page";
import BusinessCardPage from "../pages/business-card/page";
import LetterheadPage from "../pages/letterhead/page";
import BrandAssetsPage from "../pages/brand-assets/page";
import PublicCardPage from "../pages/card/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/about",
    element: <AboutPage />,
  },
  {
    path: "/philosophy",
    element: <PhilosophyPage />,
  },
  {
    path: "/properties",
    element: <PropertiesPage />,
  },
  {
    path: "/services",
    element: <ServicesPage />,
  },
  {
    path: "/team",
    element: <TeamPage />,
  },
  {
    path: "/contact",
    element: <ContactPage />,
  },
  {
    path: "/portal",
    element: <PortalPage />,
  },
  {
    path: "/portal/dashboard",
    element: <PortalDashboard />,
  },
  {
    path: "/logo-export",
    element: <LogoExportPage />,
  },
  {
    path: "/brand",
    element: <BrandPage />,
  },
  {
    path: "/business-card",
    element: <BusinessCardPage />,
  },
  {
    path: "/letterhead",
    element: <LetterheadPage />,
  },
  {
    path: "/brand-assets",
    element: <BrandAssetsPage />,
  },
  {
    path: "/card/:slug",
    element: <PublicCardPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
